import { createFileRoute } from "@tanstack/react-router";
import AdminDisputesPage from "@/admin/pages/disputes";

export const Route = createFileRoute("/admin/disputes/")({
  component: AdminDisputesPage,
});
